import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { NetworkCallService } from '../../../core/services/network-call.service';
import {SharedService} from "../../../shared/shared.service";
import { Router } from '@angular/router';
import { mergeMap, flatMap, catchError } from 'rxjs/operators';
import { retryTransientHttpErrors } from '../../../core/operators/retry-transient-http-error.operator';
import { IValidateMobileRequest, IValidateMobileResponse, IValidateMobileSuccess } from '../../../core/models/validate-mobile.model';
import { concat, of } from 'rxjs';
import * as validateMobile from '../actions/validate-mobile-number.actions';
import { RouteURL } from '../../../shared/enums';

@Injectable()
export class ValidateMobileNumberEffects {
  constructor(
    private actions$: Actions,
    private networkCallService: NetworkCallService,
    private router: Router,
    private sharedService: SharedService
  ) {}


  validateMobile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(validateMobile.validateMobileNumberRequest),
      mergeMap(action =>
        this.networkCallService
          .post<IValidateMobileRequest, IValidateMobileResponse>('Authentication/businessForgotPasscode', action.request)
          .pipe(
            mergeMap(response => {
              if (response && response.success && !response.invalidMobileNumber) {
                this.sharedService.forgotPasscodeIsUserEmailVerified = response.isUsersEmailAddressVerified;
                this.sharedService.forgotPasscodeResendOTPAfter = response.secondsUntilNextLoginAttemptAllowed;
                this.router.navigateByUrl(RouteURL.AUTH_FORGOT_PASSCODE_OTP);
              }
              return concat(of(validateMobile.validateMobileNumberSuccess({ response })));
            }),
            retryTransientHttpErrors(),
            catchError(error => {
              return of(validateMobile.validateMobileNumberFailure(error));
            })
          )
      )
    )
  );
}
